module.exports = __webpack_public_path__ + "static/media/recipe-cooking-time.02bf8999.svg";